module.exports = __webpack_public_path__ + "img/send-offer-button-mobile-ru.73bda7d8.jpg";